import { useState } from 'react'
import { companyColumns } from '../../../infrastructure/constant/columns/companyColumns'
import AgList from '../../../components/commons/AgGrid/AgList'
import { useNavigate } from 'react-router-dom'
import { settingsService } from '../../../infrastructure/services/settingsService'
import {
  GetContextMenuItemsParams,
  GridApi,
  GridReadyEvent,
  IServerSideGetRowsParams,
  MenuItemDef,
} from 'ag-grid-community'
import DeleteModal from '../../../components/commons/modals/DeleteModal/DeleteModal'
import {
  actionContextMenu,
  formattedFilters,
} from '../../../infrastructure/utils/common'
import { useSelector } from 'react-redux'
import storageService from '../../../infrastructure/services/storageService'
import { checkPermissions } from '../../../infrastructure/utils/permissions'
import { UserRoles } from '../../../infrastructure/interfaces/users'
import { useTranslation } from 'react-i18next'

const CompanyList = () => {
  const { t } = useTranslation()
  const [gridApi, setGridApi] = useState<GridApi>()
  const [deleteModal, setDeleteModal] = useState<any>(false)
  const [perPage, setPerPage] = useState<number>(14)
  const [page, setPage] = useState<number>(1)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [totalPages, setTotalPages] = useState<number>(1)
  const navigate = useNavigate()

  const user =
    useSelector((state: any) => state.auth) || storageService.getUser()

  const getContextMenu = (row: GetContextMenuItemsParams) => {
    if (!row.value) return []
    const items: MenuItemDef[] = []
    let currentUser = user?.user || storageService.getUser()

    if (
      checkPermissions(
        ['companies.*', 'companies.edit'],
        currentUser?.permissions
      ) ||
      currentUser?.role?.name === UserRoles.ADMIN
    ) {
      items.push({
        name: 'Editar',
        action: () =>
          actionContextMenu(
            'EDIT',
            row,
            null,
            location.pathname + '/create-company',
            navigate
          ),
        cssClasses: ['tw-cursor-pointer'],
      })
    }
    if (
      checkPermissions(
        ['companies.*', 'companies.delete'],
        currentUser?.permissions
      ) ||
      currentUser?.role?.name === UserRoles.ADMIN
    ) {
      items.push({
        name: 'Eliminar',
        action: () => actionContextMenu('DELETE', row, setDeleteModal),
        cssClasses: ['tw-text-alert', 'tw-cursor-pointer'],
      })
    }
    return items
  }

  const handleDelete = () => {
    settingsService
      .deleteCompany(deleteModal.id)
      .then((res) => {
        setDeleteModal(false)
        gridApi?.refreshServerSide({ purge: true })
      })
      .catch((err) => {
        setTimeout(() => {
          setDeleteModal(false)
        }, 1000)
      })
  }

  const handleDoubleClick = (row: any) => {
    let currentUser = user?.user || storageService.getUser()

    if (
      checkPermissions(
        ['companies.*', 'companies.edit'],
        currentUser.permissions
      ) ||
      currentUser?.role?.name === UserRoles.ADMIN
    ) {
      actionContextMenu(
        'EDIT',
        row,
        null,
        location.pathname + '/create-company',
        navigate
      )
    }
  }

  const onGridReady = async (params: GridReadyEvent) => {
    setGridApi(params.api)
    const updateData = (data: any) => {
      let idSequence = 1
      data?.items?.forEach(function (item: any) {
        item.id = idSequence++
      })

      const datasource = {
        async getRows(params: IServerSideGetRowsParams) {
          let filters: any = null
          if (
            params.request.filterModel &&
            Object.keys(params.request.filterModel).length > 0
          ) {
            filters = formattedFilters(params.request.filterModel)
          }

          if (params.request.sortModel.length > 0) {
            filters = {
              ...filters,
              order_field: params.request.sortModel[0].colId,
              order_direction: params.request.sortModel[0].sort,
            }
          }

          try {
            const response = await settingsService.getCompanies({
              page: params.api.paginationGetCurrentPage() + 1,
              per_page: perPage,
              from: params.request.endRow,
              ...filters,
            })

            if (response) {
              params.success({
                rowData: response.data.items,
                rowCount: response.data.meta.total,
              })
              setTotalPages(response.data.meta.last_page)
              setCurrentPage(response.data.meta.current_page)
            } else {
              params.fail()
            }
          } catch (error) {
            params.fail()
          }
        },
      }
      params.api.setServerSideDatasource(datasource)
    }

    updateData(params.api)
  }

  return (
    <>
      <AgList
        columns={companyColumns}
        currentPage={currentPage}
        totalPages={totalPages}
        onGridReady={onGridReady}
        getContextMenu={getContextMenu}
        pagination={true}
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        onRowDoubleClicked={handleDoubleClick}
      />
      <DeleteModal
        isOpen={deleteModal}
        onClose={() => setDeleteModal(false)}
        description={'¿Está seguro que desea eliminar este registro?'}
        onConfirm={handleDelete}
        title={t('titles.Eliminar entidad')}
      />
    </>
  )
}
export default CompanyList
